import { useCallback, useState } from "react";
import { getExamCertificate } from "services/sessions";

export const useGetExamCertificate = () => {
  const [base64, setBase64] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const handleGetExamCertificate = useCallback(
    async (idBasis: string | number, idModule: string | number) => {
      setLoading(true);
      setError(null);
      setBase64(null);
      try {
        const data = await getExamCertificate(idBasis, idModule);
        if (data?.base64) {
          setBase64(data.base64);
          return data.base64;
        }
        return null;
      } catch (e) {
        const err = e instanceof Error ? e : new Error("Error al obtener certificado");
        setError(err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const resetCertificate = useCallback(() => {
    setBase64(null);
    setError(null);
  }, []);

  return {
    base64,
    loading,
    error,
    handleGetExamCertificate,
    resetCertificate,
  };
};
